import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/oldstyle.css'

// Containers
import { AstraLayout } from './containers';
// Pages
import { Login, Page404, Page500, Register, ForgotPassword, VerifyOTP, LoginSSO, OAuthCallback } from './views/Pages';

// import { renderRoutes } from 'react-router-config';
// Proof of change

function normalizeOAuthCallbackRoute() {
  const callbackPath = '/astra/oauth/callback';
  const isCallbackPath = window.location.pathname === callbackPath;
  const hasOAuthParams = window.location.search && (
    window.location.search.includes('code=') ||
    window.location.search.includes('error=')
  );

  if (isCallbackPath && hasOAuthParams) {
    window.history.replaceState(
      null,
      document.title,
      `/astra/#/oauth/callback${window.location.search}`
    );
  }
}

normalizeOAuthCallbackRoute();

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/forgot-password" name="Forgot Password" component={ForgotPassword} />
          <Route exact path="/login" name="Login Page" component={Login} />
          <Route exact path="/login-sso" name="Login SSO Page" component={LoginSSO} />
          <Route exact path="/oauth/callback" name="OAuth Callback" component={OAuthCallback} />
          <Route exact path="/login/verify-otp" name="Verify OTP Page" component={VerifyOTP} />
          <Route exact path="/register" name="Register Page" component={Register} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <Route path="/" name="Home" component={AstraLayout} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
